import * as React from "react";

import {PrinterStore} from "../App";
import {StoreBase} from "shared/utilities/Store/StoreBase";
import {
    DynamicOptions,
    DynamicSearchableSelect, DynamicSearchableSelectProp
} from "shared/controls/SingleInputs/DynamicSearchableSelect/DynamicSearchableSelect";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";

export class PrinterSelection<T extends StoreBase> extends React.Component<PrinterSelectionProps<T>, PrinterSelectionState> {
    static defaultProps: Partial<PrinterSelectionProps<any>> = {};
    static printerList:DynamicOptions[]=null;
    constructor(props: PrinterSelectionProps<T>) {
        super(props);
        this.state = {
            PrinterError:false
        };
    }

    public render() {
        if(this.state.PrinterError)
            return <h3>Please go to WC Invoice/Settings and configure your printer</h3>
        else
        return (
            <DynamicSearchableSelect noOptionsMessage={'No printer were found'} placeholder={'Select a printer'} loadingMessage={'Loading printers, please wait'} {...this.props} promise={input=>this.LoadPrinters(input)}/>
        )
    }


    private async LoadPrinters(input: any):Promise<DynamicOptions[]> {
        return new Promise<DynamicOptions[]> (async resolve => {
            if(PrinterSelection.printerList==null) {
                PrinterSelection.printerList = (await WpAjaxPost.Post<{name:string,id:string}[]>('get_printers',null,{OnError:()=>{this.setState({PrinterError:true})}}))
                    .map(x=>{return {label:x.name,value:x.id,item:{label:x.name,value:x.id}}}).sort(SortFunctions.StringSort<DynamicOptions>("label"));
            }

            resolve(PrinterSelection.printerList.filter(x=>x.label.toLowerCase().indexOf(input.toLowerCase())>=0))

        });
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PrinterSelectionProps<T extends StoreBase> extends DynamicSearchableSelectProp<T>{

}

interface PrinterSelectionState {
    PrinterError:boolean;
}


class SortFunctions{
    public static StringSort<T=any>(propertyName:keyof T)
    {
        return (a,b)=>{
            if (a[propertyName] < b[propertyName])
                return -1;
            if (a[propertyName] > b[propertyName])
                return 1;
            return 0;
        }
    }
}
//#endregion "My Region"